import { _ } from "i18n";
import type { SelectValue } from "ui-kit/src/MultipleSelect/types";
import { DieLigenApiManagementConstants } from "../../pages/productManagement/apiManagement/dieLigen/DieLigenApiManagementConstants";
import { FilterSelect } from "./FilterSelect";
import { SearchInput } from "./SearchInput";
import { Cell } from "./Cell";

type SelectOption = {
    value: string | number;
    label: string;
};

interface HeaderFilterState {
    league: SelectValue | null;
    videoStatus: SelectValue | null;
    teamsheetStatus: SelectValue | null;
    homeTeam: SelectValue | null;
    awayTeam: SelectValue | null;
    country: SelectValue | null;
    category: SelectValue | null;
    eyeball_game_id: SelectValue | null;
}

interface HeaderFiltersProps {
    headerFilters: HeaderFilterState;
    onFilterChange: (field: keyof HeaderFilterState, value: SelectValue) => void;
    leagueOptions: SelectOption[];
    teamOptions: SelectOption[];
    isTeamOptionsLoading: boolean;
    isLeagueOptionsLoading: boolean;
    countryOptions: SelectOption[];
    isCountryOptionsLoading: boolean;
}

type HeaderKey = keyof typeof DieLigenApiManagementConstants.columns;

const createHeader = (key: HeaderKey) => () => (
    <Cell variant="header" translationKey={DieLigenApiManagementConstants.columns[key]} />
);

export const VideoSourceHeaderFilters = {
    eyeballGameId: ({ headerFilters, onFilterChange }: HeaderFiltersProps) => (
        <SearchInput
            value={headerFilters.eyeball_game_id}
            onChange={(value) => onFilterChange('eyeball_game_id', value)}
            placeholder={DieLigenApiManagementConstants.columns.eyeballGameId}
        />
    ),
    videoId: createHeader('videoId'),
    matchId: createHeader('matchId'),
    gameDate: createHeader('gameDate'),
    updatedAt: createHeader('updatedAt'),
    league: ({ headerFilters, onFilterChange, leagueOptions, isLeagueOptionsLoading }: HeaderFiltersProps) => (
        <FilterSelect
            options={leagueOptions}
            value={headerFilters.league}
            onChange={(value) => onFilterChange('league', value)}
            placeholder={DieLigenApiManagementConstants.columns.league}
            isLoading={isLeagueOptionsLoading}
        />
    ),
    leagueCountry: ({ headerFilters, onFilterChange, countryOptions, isCountryOptionsLoading }: HeaderFiltersProps) => (
        <FilterSelect
            options={countryOptions}
            value={headerFilters.country}
            onChange={(value) => onFilterChange('country', value)}
            placeholder={DieLigenApiManagementConstants.columns.leagueCountry}
            isLoading={isCountryOptionsLoading}
        />
    ),
    category: createHeader('category'),
    homeTeam: ({ headerFilters, onFilterChange, teamOptions, isTeamOptionsLoading }: HeaderFiltersProps) => (
        <FilterSelect
            options={teamOptions}
            value={headerFilters.homeTeam}
            onChange={(value) => onFilterChange('homeTeam', value)}
            placeholder={DieLigenApiManagementConstants.columns.homeTeam}
            isLoading={isTeamOptionsLoading}
        />
    ),
    awayTeam: ({ headerFilters, onFilterChange, teamOptions, isTeamOptionsLoading }: HeaderFiltersProps) => (
        <FilterSelect
            options={teamOptions}
            value={headerFilters.awayTeam}
            onChange={(value) => onFilterChange('awayTeam', value)}
            placeholder={DieLigenApiManagementConstants.columns.awayTeam}
            isLoading={isTeamOptionsLoading}
        />
    ),
    videoStatus: ({ headerFilters, onFilterChange }: HeaderFiltersProps) => (
        <FilterSelect
            options={DieLigenApiManagementConstants.videoStatusOptions}
            value={headerFilters.videoStatus}
            onChange={(value) => onFilterChange('videoStatus', value)}
            placeholder={DieLigenApiManagementConstants.columns.videoStatus}
        />
    ),
    teamsheetStatus: ({ headerFilters, onFilterChange }: HeaderFiltersProps) => (
        <FilterSelect
            options={DieLigenApiManagementConstants.teamsheetStatusOptions}
            value={headerFilters.teamsheetStatus}
            onChange={(value) => onFilterChange('teamsheetStatus', value)}
            placeholder={DieLigenApiManagementConstants.columns.teamsheetStatus}
        />
    ),
    actions: createHeader('actions')
}; 